import React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import withStyles from '@mui/styles/withStyles';
import { ERROR_MESSAGE_COLOR } from '../../shared/Constants';

const styles = () => ({
  root: {
    borderRadius: 5,
    textTransform: 'none',
    fontSize: '0.9375rem',
    width: '100%',
    whiteSpace: 'nowrap',
  },
  rootError: {
    borderRadius: 5,
    borderColor: ERROR_MESSAGE_COLOR,
    textTransform: 'none',
    fontSize: '0.9375rem',
    width: '100%',
    whiteSpace: 'nowrap',
  },
});

const RegularButton = ({
  classes,
  text,
  isCancel,
  isValid,
  customclass,
  error,
  ...rest
}) => (
  <Button
    {...rest}
    variant="outlined"
    className={error ? [classes.rootError, customclass].join(' ') : [classes.root, customclass].join(' ')}
    disableElevation
    disableFocusRipple
    style={isCancel ? { color: 'gray' } : {}}
    disabled={!isValid}
    tabIndex={-1}
  >
    {text}
  </Button>
);

RegularButton.defaultProps = {
  isCancel: false,
  isValid: true,
  customclass: '',
  error: false,
};

RegularButton.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  text: PropTypes.string.isRequired,
  isCancel: PropTypes.bool,
  isValid: PropTypes.bool,
  customclass: PropTypes.string,
  error: PropTypes.bool,
};

export default withStyles(styles)(RegularButton);
